module.exports = __webpack_public_path__ + "static/media/roket-min.a3988af8.png";